export { default as Login } from './Login/Login';
export { default as Main } from './Main/Main';
export { default as Orders } from './Orders/Orders';
export { default as Payments } from './Payments/Payments';
export { default as PageNotFound } from './PageNotFound/PageNotFound';



// WEBPACK FOOTER //
// ./src/pages/index.js